import { Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getQuestionTypeLabel, questionTypeEnum } from '../../../constants';
import { useBoolean } from '../../../hooks/useBoolean';
import { capitalizeFirstLetter } from '../../../utils/capitalize';
import Icon from '../../ui/Icon';

interface AddQuestionButtonsProps {
    sectionId: string;
    index: number;
    onAddQuestion: (sectionId: string, type: number, order: number, setSelectedId: (id: string | null) => void) => void;
    setSelectedId: (id: string | null) => void;
    initialOpen?: boolean;
}

const AddQuestionButtons: React.FC<AddQuestionButtonsProps> = ({ sectionId, index, onAddQuestion, setSelectedId, initialOpen = false }) => {
    const { t } = useTranslation();
    const isNewQuestion = useBoolean(initialOpen);

    return (
        <Box display="flex" justifyContent="flex-start" py={1} flexWrap="wrap" gap={1}>
            <Button startIcon={<Icon name={!isNewQuestion.value ? 'addCircle' : 'cancel'} />} onClick={isNewQuestion.toggle} color="info">
                {capitalizeFirstLetter(t('insertNewQuestion'))}
            </Button>

            {isNewQuestion.value && (
                <Box display="flex" gap={1} flexWrap="wrap">
                    {Object.values(questionTypeEnum).map((type) => (
                        <Button
                            key={type}
                            variant="outlined"
                            onClick={() => {
                                onAddQuestion(sectionId, type, index + 1, setSelectedId);
                                isNewQuestion.setFalse();
                            }}
                        >
                            {capitalizeFirstLetter(t(getQuestionTypeLabel(type)))}
                        </Button>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default AddQuestionButtons;
